import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable'
import { authRoles } from '../../auth/authRoles'

const LaboLink = Loadable(lazy(() => import('./LaboLink')))
const Report = Loadable(lazy(() => import('./Report')))
const Rules = Loadable(lazy(() => import('./Rules')))
const User = Loadable(lazy(() => import('./User')))

const adminRoutes = [
    {
        path: '/admin',
        element: <Rules />,
        auth: authRoles.admin,
    },
    {
        path: '/admin/rule',
        element: <Rules />,
        auth: authRoles.admin,
    },
    {
        path: '/admin/labolink',
        element: <LaboLink />,
        auth: authRoles.admin,
    },
    {
        path: '/admin/user',
        element: <User />,
        auth: authRoles.admin,
    },
    {
        path: '/admin/report',
        element: <Report />,
        auth: authRoles.admin,
    }
]

export default adminRoutes
